import ContainerDashboard from "../../Component/Dashboard/Dashboard"
const DashboardPage = () => {
  return (
    <div className='page-body'>
      <ContainerDashboard />
    </div>
  )
}

export default DashboardPage